// --- BASE ---
import React, { ChangeEvent } from 'react';

// --- INTERFACES ---
interface IProps {
	className?: string;
	countryCode: string;
	disabled?: boolean;
	onChange: (e: ChangeEvent<HTMLSelectElement>) => void;
	id?: string;
	name: string | undefined;
	value?: string | null | undefined;
}

// --- JSON DATA ---
import statesData from '../data/states.json';

// *** FUNCTIONAL COMPONENT ***
const SelectState = (props: IProps) => {
	// --- PROPS ---
	const { countryCode, disabled, className, id, onChange, name, value }: IProps = { ...props };

	const stateOptions: Array<JSX.Element> = [];

	stateOptions.push(<option value="">Select...</option>);

	if (typeof countryCode === 'string' && countryCode in statesData && statesData[countryCode as keyof typeof statesData] !== null) {
		const stateRows = statesData[countryCode as keyof typeof statesData];

		if (typeof stateRows === 'object' && stateRows !== null) {
			// Object.keys(stateRows).forEach((stateCode) => {
			for (const stateRow of stateRows) {
				stateOptions.push(
					<option
						selected={value === stateRow.code ? true : false}
						value={stateRow.code}>
						{stateRow.name}
					</option>
				);
			}
		}
	}

	return (
		<select
			className={className ?? ''}
			disabled={disabled}
			id={id}
			name={name}
			onChange={onChange}>
			{stateOptions}
		</select>
	);
};

export default SelectState;
